import { HashLink } from 'react-router-hash-link';


function MRR() {
  return (
    <div className="bg-projects2 absolute top-0 left-0 min-h-screen w-full bg-gray-100 flex flex-col items-center justify-start px-4 sm:px-8 scroll-mt-[80px] -mt-[80px]">
      
      <div className="w-full max-w-4xl mx-auto pt-2">
        <HashLink
            smooth
            to="/#resume-prof-projects"
            className="inline-flex items-center text-sm font-semibold text-gray-800 border border-blue-200 px-3 py-2 rounded-lg hover:bg-blue-50 hover:border-blue-400 hover:shadow-sm transition-all"
        >
            <span className="mr-1">←</span> Go back to Home
        </HashLink>
      </div>
      
      <div className="max-w-4xl w-full bg-white rounded-xl shadow-lg p-6 sm:p-10 space-y-6">
        <h1 className="text-3xl sm:text-4xl font-bold title-color">Multi Risk Rating (MRR)</h1>
        <p className="text-md text-gray-500 italic">Client: Top-tier global bank | Duration: Feb 2024 – May 2025</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Overview</h2>
          <p className="text-gray-700 mb-2">
            Contributed to the strategic implementation of the Multi Risk Rating capability, enabling the simultaneous deployment of multiple credit risk models (CRR, PD, LGD, EAD) across different regulatory environments. This initiative addressed timing disparities in regulator approvals by allowing co-existence of both legacy and newly approved models.
          </p>
          <ul className="list-disc list-inside text-gray-700 space-y-1">
            <li><strong>Role:</strong> Lead Data Analyst</li>
            <li>Defined and executed the MRR technical design as a core data distributor.</li>
            <li>Engineered 5+ scalable data pipelines for secure data egress using PySpark and SQL.</li>
            <li>Applied complex filtering, transformation, and aggregation per asset designs.</li>
            <li>Built custom logging solutions for complete data lineage and waterfall tracking.</li>
            <li>Collaborated with risk, regulatory, and engineering teams to meet compliance goals.</li>
            <li>Serving 3 regulator-grade customer risk models using prescribed regulatory logic with 90-minute SLA.</li>
            <li>Automated data asset deployment using Jenkins, ensuring consistent, version-controlled delivery into Hadoop (HDFS).</li>
            <li>Implemented Airflow BashOperator to trigger file-watcher scripts, enabling 100% automated, event-driven DAG execution upon file arrival and eliminating all manual triggers across 6+ data sources.</li>
            <li>Orchestrated data workflows via Airflow, enabling reliable execution of multi-stage pipelines (5–10 stages per DAG) with strict 90-minute SLA adherence and 100% job success rate in production.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Key Responsibilities</h2>
          <ul className="list-disc list-inside text-gray-700 space-y-2">
            <li>
              Enabled the bank to comply with multi-jurisdictional regulatory mandates by allowing early implementation of approved models.
            </li>
            <li>
              Reduced risk of regulatory delays by decoupling model rollouts from unified approval timelines.
            </li>
            <li>
              Ensured complete auditability and governance of data flow within the MRR architecture.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-700 mb-2">Impact</h2>
          <p className="text-gray-700">
            Strengthened the bank’s risk modeling infrastructure by allowing parallel support of legacy and future-ready models. The initiative improved operational agility and compliance assurance, creating a robust framework for dynamic model lifecycle management.
          </p>
        </section>

      </div>
    </div>
  );
}

export default MRR;
